import { queryString } from '@shared/hooks/recoil-query';
import { api_ } from '@shared/plugIn/axios';
import { LowerRole } from '@shared/types';

import {
  GiftSupplySettlement,
  GiftSupplySettleBody,
  GiftSupplySettleResult,
  GiftSupplySettlementPatchBody,
} from './giftSupplySettlement.interface';

// 조회 prefix는 호출자 role에 따라 분기한다.
// - Admin: 전체 정산 조회
// - GiftAgent(마리): /gift-agent 읽기 전용 — 마리 직접정산(accountEntity=Mari) 건만 백엔드에서 스코프
export type GiftSupplySettlementRole =
  | LowerRole.Admin
  | LowerRole.GiftBrandSeller
  | LowerRole.GiftAgent;

// ===== 조회 =====

export const listGiftSupplySettlements = async (
  filter: Record<string, unknown> = {},
  populate: unknown[] = [],
  options: Record<string, unknown> = { sort: { year: -1, month: -1 } },
  role: GiftSupplySettlementRole = LowerRole.Admin,
): Promise<GiftSupplySettlement[]> => {
  const { data } = await api_.get<GiftSupplySettlement[]>(
    `/${role}/gift-supply-settlement?${queryString({ filter, populate, options })}`,
  );
  return data;
};

export const getGiftSupplySettlementById = async (
  id: string,
  populate: unknown[] = [],
  role: GiftSupplySettlementRole = LowerRole.Admin,
): Promise<GiftSupplySettlement> => {
  const { data } = await api_.get<GiftSupplySettlement>(
    `/${role}/gift-supply-settlement/${id}?${queryString({ populate })}`,
  );
  return data;
};

export const countGiftSupplySettlements = async (
  filter: Record<string, unknown> = {},
  role: GiftSupplySettlementRole = LowerRole.Admin,
): Promise<number> => {
  const { data } = await api_.get<number>(
    `/${role}/gift-supply-settlement/count?${queryString({ filter })}`,
  );
  return data;
};

// ===== 집행 (Admin 전용) =====

export const settleGiftSupply = async (
  body: GiftSupplySettleBody,
): Promise<GiftSupplySettleResult> => {
  const { data } = await api_.post<GiftSupplySettleResult>(
    `/${LowerRole.Admin}/gift-supply-settlement/settle`,
    body,
  );
  return data;
};

// ===== 수정 (Admin 전용) =====

export const patchGiftSupplySettlement = async (
  id: string,
  body: GiftSupplySettlementPatchBody,
): Promise<GiftSupplySettlement> => {
  const { data } = await api_.patch<GiftSupplySettlement>(
    `/${LowerRole.Admin}/gift-supply-settlement/${id}`,
    body,
  );
  return data;
};

// ===== 삭제 (Admin 전용) =====

export const deleteGiftSupplySettlement = async (id: string): Promise<void> => {
  await api_.delete(`/${LowerRole.Admin}/gift-supply-settlement/${id}`);
};
